import { Dispatch } from 'redux'
import { SomeThingWentWrong } from '../../../../common/utils/messagesContants'
import { startLoading, stopLoading, LoadingTypes } from '@labrav/common'
import { SyncObjectType } from './reducer'
import { fetchPartnerObject } from '../../../../common/api'
import { AxiosError } from 'axios'
import { RootState } from '../../../../store'
import { errorLogger } from '../../../../common/utils/errorLogger'
import { getErrorMessages } from '../../../../common/utils/error'
import { normalizePartnerObjectDetail } from '../../../../common/utils/partnerObjectMapper'

export enum PartnerObjectActionTypes {
  SHOW_SYNC_PANEL = 'SHOW_SYNC_PANEL',
  HIDE_SYNC_PANEL = 'HIDE_SYNC_PANEL',
  SET_SYNC_OBJECT_DATA = 'SET_SYNC_OBJECT_DATA',
  SET_PARTNER_OBJ_ERROR = 'SET_PARTNER_OBJ_ERROR',
  CLEAR_SYNC_OBJECT_DATA = 'CLEAR_SYNC_OBJECT_DATA',
}

export const getPartnerObject =
  (partnerId: string, objectId: string, objectType: CRMObjectType) =>
  (dispatch: Dispatch, getState: () => RootState) => {
    dispatch(showSyncPanel())
    dispatch(startLoading(LoadingTypes.GENERAL))
    return fetchPartnerObject(partnerId, objectId, 'syncs', objectType)
      .then(res => {
        dispatch(setSyncObjectData(res.data))
      })
      .catch((error: unknown) => {
        const errorMessage = getErrorMessages([SomeThingWentWrong])(
          (error as AxiosError<ErrorResponse>).response
        )
        dispatch(setSyncObjectError(errorMessage))
        const globalState = getState()
        errorLogger({ globalState })(error as Error)
      })
      .finally(() => {
        dispatch(stopLoading(LoadingTypes.GENERAL))
      })
  }

export const setSyncObjectData = (
  object: SyncObjectType | Record<string, unknown>
) => {
  const normalized =
    'syncAttempts' in object && Array.isArray(object.syncAttempts)
      ? (object as SyncObjectType)
      : normalizePartnerObjectDetail(object as Record<string, unknown>)
  return {
    type: PartnerObjectActionTypes.SET_SYNC_OBJECT_DATA,
    payload: normalized,
  }
}

export const clearSyncObjectData = () => ({
  type: PartnerObjectActionTypes.CLEAR_SYNC_OBJECT_DATA,
})
export const showSyncPanel = () => ({
  type: PartnerObjectActionTypes.SHOW_SYNC_PANEL,
})

export const hideSyncPanel = () => ({
  type: PartnerObjectActionTypes.HIDE_SYNC_PANEL,
})

export const setSyncObjectError = (error: unknown) => ({
  type: PartnerObjectActionTypes.SET_PARTNER_OBJ_ERROR,
  payload: error,
})
